module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-left-0f6eb346.svg";